/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { parseData } from '@ups/xplat/utils';
import { MyHttpClientFactory, environment } from '@ups/xplat/core';
import { HttpClient } from '@angular/common/http';
import { NameAndLongDto } from '@ups/xplat/api/dto';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const GET_TERMINATION_REASONS = '/api/codelist/termreasons';
const GET_REHIRE_STATUSES = '/api/codelist/rehirestatuses';
const GET_LIST_OF_PRCOS_BY_SSN = '/api/hrrm/employee/prco/{:SSN}';
const GET_EMPLOYEE_TYPES = '/api/codelist/employeetypes';
const GET_JOB_CATEGORIES = '/api/codelist/jobcategories';
const GET_LTD_CLASSES = '/api/codelist/ltdclasses';

const GET_LICENSE_TYPES = '/api/codelist/licensetypes';
const GET_LICENSE_CLASSES = '/api/codelist/licenseclasses';
const GET_I9_STATUSES = '/api/codelist/i9statuses';
const GET_CRAFTS = '/api/codelist/crafts';
const GET_CLASSES = '/api/codelist/classes';
const GET_CRAFTS_BY_PRCO = '/api/codelist/crafts/{:prCo}';
const GET_CLASSES_BY_PRCO_AND_CRAFT = '/api/codelist/classes/{:prCo}/{:craft}';

//Background
const GET_BACKGROUND_TYPES = '/api/codelist/backgroundtype';
const GET_TRAINING_INSTITUTIONS_ODATA =
  '/api/codelist/training/institution/odata';

const GET_EMPLOYEES_DROPDOWN = '/api/hrrm/employee/all/dropdown';
@Injectable({
  providedIn: 'root',
})
export class CodelistVpService {
  http: HttpClient;

  constructor(private httpFactory: MyHttpClientFactory) {
    this.http = httpFactory.createHttpClient(environment.urls.viewpointAPI);
  }

  public getPercosBySSN(ssn: string): any {
    const url = GET_LIST_OF_PRCOS_BY_SSN.split('{:SSN}').join(ssn);
    return this.http.get(url).toPromise().then(parseData);
  }

  public getRehireStatuses(): any {
    const url = GET_REHIRE_STATUSES;
    return this.http.get(url).toPromise().then(parseData);
  }

  public getLicenseTypes(): any {
    const url = GET_LICENSE_TYPES;
    return this.http.get(url).toPromise().then(parseData);
  }

  public getTerminationReasons(): Promise<NameAndLongDto[]> {
    const url = GET_TERMINATION_REASONS;
    return this.http.get<NameAndLongDto[]>(url).toPromise().then(parseData);
  }

  public getEmployeeTypes(): any {
    const url = GET_EMPLOYEE_TYPES;
    return this.http.get(url).toPromise().then(parseData);
  }

  public getJobCategoryList(): any {
    const url = GET_JOB_CATEGORIES;
    return this.http.get(url).toPromise().then(parseData);
  }

  public getLicenseClasses(): any {
    const url = GET_LICENSE_CLASSES;
    return this.http.get(url).toPromise().then(parseData);
  }

  public getI9Statuses(): any {
    const url = GET_I9_STATUSES;
    return this.http.get(url).toPromise().then(parseData);
  }

  public handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  public getLTDClassLists(): any {
    const url = GET_LTD_CLASSES;
    return this.http.get(url).toPromise().then(parseData);
  }

  public getCraftsByPRCo(prCo: string): Promise<NameAndLongDto[]> {
    const url = GET_CRAFTS_BY_PRCO.split('{:prCo}').join(prCo);
    return this.http.get<NameAndLongDto[]>(url).toPromise().then(parseData);
  }

  public getCrafts(): Observable<NameAndLongDto[]> {
    return this.http.get<NameAndLongDto[]>(GET_CRAFTS).pipe(map(parseData));
  }

  public getClasses(): Observable<NameAndLongDto[]> {
    return this.http.get<NameAndLongDto[]>(GET_CLASSES).pipe(map(parseData));
  }

  public getClassesByPRCoAndCraft(
    prCo: string,
    craft: string
  ): Promise<NameAndLongDto[]> {
    const url = GET_CLASSES_BY_PRCO_AND_CRAFT.split('{:prCo}')
      .join(prCo)
      .split('{:craft}')
      .join(craft);
    return this.http.get<NameAndLongDto[]>(url).toPromise().then(parseData);
  }

  public getBackGroundTypesQuery(query: string, top: number = 15): any {
    // NOTE: due to having search-ex capability, the query is now generated on the kendo komponent itself...

    let url = GET_BACKGROUND_TYPES + `?$format=json`;
    if (top) {
      url += `&$top=${top}`;
    }

    if (query !== '') url += '&' + query;

    return this.http
      .get(url)
      .toPromise()
      .then((data) => parseData(data))
      .catch(this.handleError);
  }

  public getTrainingInstitutionOData(query: string, top: number = 15): any {
    // NOTE: due to having search-ex capability, the query is now generated on the kendo komponent itself...

    let url = GET_TRAINING_INSTITUTIONS_ODATA + `?$format=json`;
    if (top) {
      url += `&$top=${top}`;
    }

    if (query !== '') url += '&' + query;

    return this.http
      .get(url)
      .toPromise()
      .then((data) => parseData(data))
      .catch(this.handleError);
  }

  public getEmployeesDropdown(searchString = ''): any {
    const url = GET_EMPLOYEES_DROPDOWN + '?searchString=' + searchString;
    return this.http
      .get(url)
      .toPromise()
      .then((data) => parseData(data));
  }
}
